import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { Listing } from '@df/catalog-ui/listing/listing';
import { ImageModule } from '@df/module-image/image.module';
import { UgcImage } from '@df/ugc-image/ugc-image';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import uniqBy from 'lodash-es/uniqBy';
import { ShellComponent } from '../../../ui/display/local-shell.component';
import { UgcImageGalleryComponent } from './ugc-image-gallery.component';
import { NUgcImageGallery } from './ugc-image-gallery.namespace';
@Component({
    selector: 'ugc-image-gallery-listing',
    templateUrl: './ugc-image-gallery-listing.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        IfSizeDirective,
        TranslationModule,
        ImageModule,
        ShellComponent,
        ICmsClientModule,
        GridModule,
        ICmsClientModule
    ]
})
export class UgcImageGalleryListingComponent extends UgcImageGalleryComponent implements OnChanges {
    listing?: Listing<UgcImage>;
    _gridS: 1 | 2 = 1;
    @Input()
    override content?: NUgcImageGallery.IListingData;
    protected finish(ugcImages: UgcImage[]) {
        if (this.listing) {
            this.listing.setSourceModels(ugcImages);
        } else {
            this.listing = new Listing<UgcImage>(
                {
                    type: 'ugcImages',
                    infScrollStep: this.content?.infScrollStep,
                    initialStepsVisible: this.content?.initialStepsVisible,
                    storage: false
                },
                ugcImages
            );
        }
        this.detectChanges();
    }
    get gridS(): 1 | 2 {
        return this._gridS;
    }
    set gridS(gridS: 1 | 2) {
        this._gridS = gridS;
        this.detectChanges();
    }
    increaseLimit(): void {
        this.listing?.increaseLimit();
        this.detectChanges();
    }

    get modelsWithoutDuplicates(): UgcImage[] {
        return uniqBy(this.listing?.models || [], model => model.data?.image);
    }
}
